<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AssetRedemption, { cancelRedemptionCode } from '@/model/dataLayer/api/MembershipSystem/AssetRedemption'
import { showErrorMessage, showSuccessMessage } from '@/model/utils/utils'
import { useBaseFormDialogStore } from '@/model/baseForm/baseFormDialogStore'
import IKUtils from 'innerken-js-utils'

export default {
  name: 'AssetRedemption',
  components: {
    IkDataTable
  },
  data () {
    return {
      redemptionCode: null,
      model: AssetRedemption
    }
  },
  async mounted () {
    await this.reload()
  },
  computed: {
    schemas () {
      return [
        {
          key: 'reason',
          name: 'reason',
          hint: '撤销兑换码的原因',
          required: true,
          componentProps: {
            placeholder: '请输入撤销兑换码的原因',
            rules: [v => !!v || '撤销原因不能为空', v => v.length <= 200 || '撤销原因不能超过200个字符']
          }
        }
      ]
    },
    getStatusColor () {
      return (status) => {
        if (status === 'REDEEMED') return 'info'
        if (status === 'ACTIVE') return 'green'
        if (status === 'EXPIRED') return 'red'
        return ''
      }
    }
  },
  methods: {
    async submitRevoke (info) {
      await cancelRedemptionCode(this.redemptionCode.code, info)
      showSuccessMessage('兑换码撤销成功！')
      await this.$refs.table.reload()
    },
    async removeRecord (item) {
      try {
        // Deep copy the item to avoid modifying the original
        this.redemptionCode = IKUtils.deepCopy(item)

        const store = useBaseFormDialogStore()

        // Define the schema for the revoke dialog
        const schema = {
          title: '撤销兑换码',
          subtitle: '请输入撤销原因',
          schemas: this.schemas
        }

        // Open the dialog and wait for the result
        const result = await store.editItem(schema)

        // Handle the result
        if (result) {
          await this.submitRevoke(result)
        }
      } catch (error) {
        console.error('Error revoking redemption code:', error)
        showErrorMessage('撤销兑换码失败: ' + (error.message || '未知错误'))
      }
    },
    async reload () {

    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      :use-default-action="false"
      entity-name="兑换码管理"
      icon="mdi-cash-usd"
    >
      <template #item.operation="{item}">
        <div class="d-flex">
          <v-tooltip
            bottom
            color="grey lighten-4"
          >
            <template #activator="{on,attrs}">
              <div
                class="d-flex align-center"
                v-bind="attrs"
                v-on="on"
              >
                <v-btn
                  elevation="0"
                  icon
                  small
                  @click.stop="removeRecord(item)"
                >
                  <v-icon>
                    mdi-reload
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <div
              class="text-caption text--secondary"
            >
              {{ '撤销' }}
            </div>
          </v-tooltip>
        </div>
      </template>
      <template #item.statusDisplay="{item}">
        <v-chip
          :color="getStatusColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
    </ik-data-table>
    <!-- BaseFormDialog is used for the revoke dialog -->
  </v-container>
</template>

<style scoped>

</style>
